export const setOffline = isOffline => {
  return (dispatch, getState) => {
    dispatch({ type: 'SYSTEM_OFFLINE', isOffline });
  };
};
